import { rootApi } from "../../api/rootApi";

export const EmailCredentialApiTenant = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllTenantEmailCredential: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: "/tenant/emailCredential",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    createTenantEmailCredential: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/emailCredential/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),

    updateTenantEmailCredential: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/emailCredential/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),

    deleteTenantEmailCredential: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/emailCredential/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const {
  useGetAllTenantEmailCredentialMutation , useCreateTenantEmailCredentialMutation , useDeleteTenantEmailCredentialMutation , useUpdateTenantEmailCredentialMutation
} = EmailCredentialApiTenant;
